import { BaseValueText } from "./styled";
export default BaseValueText;